// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__i0oxH","radioRow":"SimpleQuestionBuilderModal_radioRow__2yHRP"};